<template>
  <section class="categories">
    <div class="categories__grid">
      <nuxt-link
        v-for="category in categories"
        :key="category.uuid"
        :class="[
          'categories__pill',
          {
            'categories__pill--gray': gray,
          },
        ]"
        :to="`/blog/categories/${category.slug}`"
      >
        {{ category.name }}
      </nuxt-link>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { BlogCategoryStoryblok, Story } from '@/types'

interface Props {
  categories: Story<BlogCategoryStoryblok>[]
  gray?: boolean
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.categories {
  &__pill {
    padding: 8px 16px;
    background-color: white;
    color: var(--color-text);
    border-radius: 12px;

    &:hover {
      color: var(--color-link);
      text-decoration: none;
    }

    &--gray {
      @include shadow-small-soft;

      background-color: var(--gray-100);
      color: var(--color-text);
    }
  }

  &__grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
}
</style>
